// In-editor identifier rename — occurrence finding, quote/comment/string-aware
// via the shared tokenizer (strings, comments, numbers, @vars, :params are
// distinct token types, so they're never matched). Buffer scope only: this
// renames text in the editor, it does NOT alter the database. Pure + tested.
import { tokenize } from './sqlformat.js';

const strip = (v) => String(v).replace(/`/g, '');

// identAt(text, pos) → {name, from, to, quoted} for the identifier token covering
// pos (caret may sit at either edge), else null. Only `ident` tokens rename —
// keywords/strings/comments are deliberately excluded.
export function identAt(text, pos) {
  for (const t of tokenize(text)) {
    if (t.t === 'ident' && pos >= t.start && pos <= t.end) {
      return { name: strip(t.v), from: t.start, to: t.end, quoted: t.v.startsWith('`') };
    }
    if (t.start > pos) break;
  }
  return null;
}

// findOccurrences(text, name) → every `ident` token whose stripped value equals
// `name`, case-insensitively (MySQL identifiers compare case-insensitively, so
// `Id`/`ID`/`id` are the same column → renamed together). Skips strings,
// comments, keywords, vars by construction.
export function findOccurrences(text, name) {
  const target = strip(name).toLowerCase();
  if (!target) return [];
  const out = [];
  for (const t of tokenize(text)) {
    if (t.t === 'ident' && strip(t.v).toLowerCase() === target) {
      out.push({ from: t.start, to: t.end, quoted: t.v.startsWith('`') });
    }
  }
  return out;
}

// needsQuote — a name that isn't a bare identifier must be backtick-quoted.
export function needsQuote(name) {
  return !/^[A-Za-z_$][\w$]*$/.test(String(name));
}

// renderName — the replacement text for one occurrence: backtick-quote when the
// new name needs it OR the occurrence being replaced was itself backticked
// (preserve the user's quoting intent).
export function renderName(newName, occurrenceQuoted) {
  return (occurrenceQuoted || needsQuote(newName)) ? '`' + newName + '`' : newName;
}
